module.exports = __webpack_public_path__ + "img/8.5f6240d2.png";